/*
 * @Author: dongqingming
 * @Date: 2021-07-28 11:32:55
 * @LastEditTime: 2023-03-08 15:04:04
 * @LastEditors: jiangfeng
 * @Description: Do not edit
 * @FilePath: /governance-driver-projects/packages/acceptor-center/src/router/index.js
 * no bug no code
 */
import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const GPUX_PAGE_CONFIG = process.env.GPUX_PAGE_CONFIG;
const { extra } = GPUX_PAGE_CONFIG;

const routes = [
  {
    path: '/',
    name: 'submit',
    component: () =>
      import(/* webpackChunkName: "submit" */ '../views/submit.vue')
  },
  {
    path: '/progress',
    name: 'progress',
    component: () =>
      import(/* webpackChunkName: "progress" */ '../views/progress.vue')
  },
  {
    path: '/intercept',
    name: 'intercept',
    component: () =>
      import(/* webpackChunkName: "intercept" */ '../views/intercept.vue')
  },
  {
    path: '/rule',
    name: 'rule',
    component: () => import(/* webpackChunkName: "rule" */ '../views/rule.vue')
  },
  {
    path: '/preview',
    name: 'preview',
    component: () => import(/* webpackChunkName: "rule" */ '../views/preview.vue')
  },
  {
    path: '/result',
    name: 'result',
    component: () => import(/* webpackChunkName: "result" */ '../views/result.vue')
  }
];

const router = new VueRouter({
  mode: 'history',
  routes,
  base: `${extra.base_route_config}`
});

console.log('extra.base_route_config', extra.base_route_config);

export default router;
